import * as R from 'ramda';
import { ActionType } from '../core/redux/actionType';
import { TextDirection } from './textDirection';
import { AppState } from '../core/redux/appState';
import { Action } from 'redux';
import { LocaleState } from './localeState';
import { Language } from './models';


type SetLocaleAction = {
  type: ActionType.SetLocaleAction;
  language: Language | undefined;
  textDirection: TextDirection | undefined;
};

export const setLocaleAction = (
  language: Language | undefined,
  textDirection: TextDirection | undefined,
): SetLocaleAction => ({
  type:          ActionType.SetLocaleAction,
  language:      language,
  textDirection: textDirection,
});

export const setLocaleReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.SetLocaleAction) {
    return state;
  }

  const sla = action as SetLocaleAction;

  return R.mergeDeepRight(
    state,
    {
      locale: {
        lang:          sla.language ?? state.locale.lang,
        textDirection: sla.textDirection ?? state.locale.textDirection,
        translations:  state.locale.translations,
      } as LocaleState,
    },
  );
};
